import {
    OutreachStatus,
    OutreachStatusFilter,
    RecruitingStatusFilter,
    SystemStatus,
} from '__generated__/graphql'

export function getOutreachStatusLabel(status: OutreachStatus): string {
    switch (status) {
        case OutreachStatus.NonPoach:
            return 'Non-Poach'
        case OutreachStatus.TreadCarefully:
            return 'Tread Carefully'
        case OutreachStatus.CpiPlaced:
            return 'CPI Placed'
        case OutreachStatus.NoStatus:
            return 'No Status'
        default:
            return status
    }
}

export function getRecruitingStatusFilterLabel(
    status: RecruitingStatusFilter
): string {
    switch (status) {
        case RecruitingStatusFilter.FinalStages:
            return 'Final Stages'
        case RecruitingStatusFilter.ActivelyRecruiting:
            return 'Actively Recruiting'
        case RecruitingStatusFilter.Opportunistic:
            return 'Opportunistic'
        case RecruitingStatusFilter.HoldingOut:
            return 'Holding Out'
        case RecruitingStatusFilter.NotRecruiting:
            return 'Not Recruiting'
        case RecruitingStatusFilter.DoNotCall:
            return 'Do Not Call'
        case RecruitingStatusFilter.RedFlag:
            return 'Red Flag'
        case RecruitingStatusFilter.NoStatus:
            return 'No Status'
        default:
            return status
    }
}

export function getSystemStatusLabel(status: SystemStatus): string {
    switch (status) {
        case SystemStatus.Null:
            return 'null'
        case SystemStatus.EmailedInvitation:
            return 'Emailed Invitation'
        case SystemStatus.Unregistered:
            return 'Unregistered'
        case SystemStatus.OnHold:
            return 'On Hold'
        case SystemStatus.InProcess:
            return 'In Process'
        case SystemStatus.SentScheduler:
            return 'Sent Scheduler'
        case SystemStatus.Met:
            return 'Met'
        case SystemStatus.NoStatus:
            return 'No Status'
        default:
            return status
    }
}

export function getOutreachStatusFilterLabel(
    status: OutreachStatusFilter
): string {
    switch (status) {
        case OutreachStatusFilter.NonPoach:
            return 'Non-Poach'
        case OutreachStatusFilter.TreadCarefully:
            return 'Tread Carefully'
        case OutreachStatusFilter.CpiPlaced:
            return 'CPI Placed'
        case OutreachStatusFilter.NoStatus:
            return 'No Status'
        default:
            return status
    }
}
